<template>
  <div id="ThirdParty">
    <ots-main-title :mainTopBtn="mainTopBtn"></ots-main-title>
    <ots-table-group-new
      ref="ots-table"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
    ></ots-table-group-new>

    <!-- 新增第三方成绩项 -->
    <ots-custom-dialog :dialog.sync="addDialog" title="新增第三方成绩项" width="40%">
      <template v-slot:content>
        <span style="color: #FE5859;">*</span>
        <span>第三方成绩项名称：</span>
        <el-input v-model="typeName" placeholder="请录入"></el-input>
      </template>
      <template v-slot:footer>
        <el-button round @click="addDialog = false">取消</el-button>
        <el-button round @click="addSave" plain type="primary">保存</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 编辑 -->
    <ots-custom-dialog :dialog.sync="editDialog" title="编辑第三方成绩项" width="40%">
      <template v-slot:content>
        <span style="color: #FE5859;">*</span>
        <span>第三方成绩项名称：</span>
        <el-input v-model="typeName" placeholder="请录入"></el-input>
      </template>
      <template v-slot:footer>
        <el-button round @click="editDialog = false">取消</el-button>
        <el-button round @click="editSave" plain type="primary">保存</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getTypeListAPI, insertTypeNameAPI, updateTypeNameAPI, operationTypeAPI } from "@/http/modules/examSet/score";
export default {
  
  data() {
    return {
      mainTopBtn: [
        {
          title: "新增第三方成绩项",
          plain: false,
          fn: this.addSet,
        },
      ],
      typeName: "",
      tableHeader: [
        {
          title: "第三方成绩",
          prop: "typeName",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              // function(scope) {
              //   return scope.row.applyState !== "未申请" ? "查看": "";
              // },
              click: this.edit,
              // formatter: function(scope) {
              //   return scope.row.applyState == "未申请"; 
              // 
              // },
            },
            {
              title: "删除",
              // function(scope) {
              //   return scope.row.applyState == "未申请" ? "提交申请": "";
              // },
              click: this.delete,
              // formatter: function(scope) {
              //   return scope.row.defaultFlag != 1;
              // },
            },
            {
              title:  function(scope) {
                return scope.row.stopFlag == 0 ? "停用": "启用";
              },
              click: this.stopUse,
              // formatter: this.auditFormat,
              
            },
          ],
        },
      ],
      tableData: [],
      addDialog: false,
      editDialog: false,
      typeId: "",
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    // 新增第三方成绩项
    addSet() { 
      this.typeName = "",
      this.addDialog = true;
    },
    // 保存 => 新增第三方成绩项
    async addSave() {

      if (this.typeName.length > 20) {
        this.$message.error("第三方成绩项名称，不超过20个字符！");
        return;
      } else if (!this.typeName) {
        this.$message.error("请输入第三方成绩项名称！");
        return;
      }

      const { code } = await insertTypeNameAPI({typeName: this.typeName});
      if (code) {
        this.search();
        this.$message.success("保存成功！");
        this.addDialog = false;
      }
    },
    // 搜索
    async search() {
      const { data, code } = await getTypeListAPI();
      if (code) {
        this.tableData = data ? data: [];
      }
    },
    // 编辑
    edit(row) {
      this.editDialog = true;
      this.typeName = row.typeName;
      this.typeId = row.typeId;
    },
    // 保存编辑 
    async editSave() {
      if (this.typeName.length > 20) {
        this.$message.error("第三方成绩项名称，不超过20个字符！");
        return;
      } else if (!this.typeName) {
        this.$message.error("请输入第三方成绩项名称！");
        return;
      }
      let params = {
        typeId: this.typeId,
        typeName: this.typeName
      }
      const { code } = await updateTypeNameAPI(params);
      if (code) {
        this.search();
        this.$message.success("编辑成功！");
        this.editDialog = false;
      }
    },
    // 删除
    delete(row) {
      if (row.defaultFlag == 1) {
        this.$confirm(`确认删除第三方成绩：${row.typeName}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            typeId: row.typeId,
            operationType: 2
          }
          operationTypeAPI(params).then(({code}) => {
            if (code) {
              this.$message.success("删除成功！");
              this.search();
            }
          })
        }).catch(() => {});        
      } else {
        this.$alert(`该成绩项已被使用，不可被删除！`, "提示", {
          confirmButtonText: '确定',
        });
      }
    },
    // 停用
    stopUse(row) {
      let stopFlag = row.stopFlag;
      this.$confirm(`确认${stopFlag == 0 ? '停用': '启用'}第三方成绩：${row.typeName}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          typeId: row.typeId,
          operationType: stopFlag == 0 ? 1: 0
        }
        operationTypeAPI(params).then(({code}) => {
          if (code) {
            this.$message.success(`${stopFlag == 0 ? '停用': '启用'}成功！`);
            this.search();
          }
        })
      }).catch(() => {});
    },

  }
}
</script>